import UUID from 'uuid/v4';
import apis from '../app/apis';
import cts from '../app/cts';

/**
 * Store
 */
import store from '../configureStore';
import EventTracker from '../helpers';


/**
 * Actions
 */
import { app } from '../redux/actions';

const {
  setDistrictId,
  setProjectId,
  setLocality,
  setUuid,
  setDistricts,
  setPluginId,
} = app;


/**
 * Download config
 * @private
 * @param {string} pluginId
 */
const downloadConfig = async (pluginId) => {
  const formData = new FormData();
  formData.append('plugin_id', pluginId);
  const { data } = await cts('post', apis.setupFromPluginIdApi(), formData);
  return data[0] || '';
};


/**
 * Set districts array if plugin is multi district
 *
 * @param {array} districts Districts
 */
const setDistrictsArray = (districts) => {
  store.store.dispatch(setDistricts(districts));

  /**
   * District id
   */
  store.store.dispatch(setDistrictId(districts[0].district_id));


  /**
   * Locality id
   */
  store.store.dispatch(setLocality(districts[0].cms_locality_id));
};


const setup = async (pluginId) => {
  /**
   * Read values from store
   */
  const state = store.store.getState();

  try {
    /**
     * Download Package
     */
    const configs = await downloadConfig(pluginId);
    if (configs) {
      /**
       * Uuid
       */
      const { uuid } = state.app;
      if (!uuid) {
        store.store.dispatch(setUuid(UUID()));
      }
      const { project_id, distritcs: districts, plugin_id } = configs;


      /**
       * Set project
       */
      store.store.dispatch(setProjectId(project_id));


      /**
       * Set plugin id
       */
      store.store.dispatch(setPluginId(plugin_id));

      /**
       * Set district
       */
      setDistrictsArray(districts);

      EventTracker('Plugin Visit');
    }
  } catch (e) {
    // TODO: Log Error
  }
};

export default setup;
